import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import { CHECKIN_QUESTIONS, formatWeekLabel } from '../../utils/weeklyCheckin';
import './WeeklyCheckInsTab.css';

export default function WeeklyCheckInsTab({ clientId }) {
  const [checkins, setCheckins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    loadCheckins();
  }, [clientId]);

  async function loadCheckins() {
    setLoading(true);
    const { data } = await supabase
      .from('weekly_checkins')
      .select('*')
      .eq('client_id', clientId)
      .order('week_of', { ascending: false })
      .limit(20);

    setCheckins(data || []);
    // Auto-expand the most recent one
    if (data && data.length > 0) {
      setExpandedId(data[0].id);
    }
    setLoading(false);
  }

  if (loading) {
    return <div className="tab-loading">Loading check-ins...</div>;
  }

  if (checkins.length === 0) {
    return (
      <div className="protocol-empty">
        <p>No weekly check-ins yet.</p>
        <p style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)' }}>
          Check-ins will appear here once your client submits their first Sunday check-in.
        </p>
      </div>
    );
  }

  return (
    <div className="wci-tab">
      {checkins.map((checkin) => {
        const isExpanded = expandedId === checkin.id;
        const answeredQuestions = CHECKIN_QUESTIONS.filter(
          (q) => checkin[q.key] && checkin[q.key].trim().length > 0
        );
        const submittedDate = new Date(checkin.submitted_at).toLocaleDateString('en-US', {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
        });

        return (
          <div key={checkin.id} className="wci-entry">
            <button
              className="wci-entry-header"
              onClick={() => setExpandedId(isExpanded ? null : checkin.id)}
            >
              <div className="wci-entry-left">
                <span className="wci-entry-week">{formatWeekLabel(checkin.week_of)}</span>
                <span className="wci-entry-meta">
                  Submitted {submittedDate} · {answeredQuestions.length}/{CHECKIN_QUESTIONS.length} answered
                </span>
              </div>
              <span className={`wci-chevron ${isExpanded ? 'wci-chevron-open' : ''}`}>›</span>
            </button>

            {isExpanded && (
              <div className="wci-entry-body">
                {CHECKIN_QUESTIONS.map((q) => {
                  const answer = checkin[q.key];
                  if (!answer || !answer.trim()) return null;
                  return (
                    <div key={q.key} className="wci-qa">
                      <div className="wci-qa-question">{q.question}</div>
                      <div className="wci-qa-answer">{answer}</div>
                    </div>
                  );
                })}
                {answeredQuestions.length === 0 && (
                  <p className="wci-no-answers">No answers provided for this week.</p>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
